export default {
  namespaced: true,
  state: {
    all: {
      home: {
        admin: false,
        icon: "mdi-home",
        homeDisplay: false,
        items: [
          {
            title: "Home",
            icon: "mdi-home",
            iconClass: "",
            subtitle: "List all available operations in this application",
            path: "/",
          },
        ],
      },
      history: {
        admin: false,
        homeDisplay: true,
        icon: "mdi-history",
        items: [
          {
            title: "Orders",
            icon: "mdi-silverware-variant",
            iconClass: "",
            subtitle: "List and search orders",
            path: "/orders",
          },
        ],
      },
      analyze: {
        admin: false,
        homeDisplay: true,
        icon: "mdi-chart-areaspline",
        items: [
          {
            title: "Daily",
            icon: "mdi-calendar-today",
            iconClass: "",
            subtitle: "Analyze daily orders",
            path: "/daily",
          },
          {
            title: "Timeseries",
            icon: "mdi-timetable",
            iconClass: "",
            subtitle:
              "Make decisions based on orders patterns for a given kitchen/concept/platform",
            path: "/timeseries",
          },
        ],
      },
      management: {
        admin: true,
        homeDisplay: true,
        icon: "mdi-stethoscope",
        items: [
          {
            title: "Errors",
            icon: "mdi-exclamation",
            iconClass: "",
            subtitle: "List and retry errors",
            path: "/errors",
          },
          {
            title: "Errors V2",
            icon: "mdi-exclamation",
            iconClass: "",
            subtitle: "List and retry errors",
            path: "/errors_v2",
          },
          {
            title: "Unlabelled",
            icon: "mdi-tag-text-outline",
            iconClass: "",
            subtitle: "List and labelize unknown items",
            path: "/unlabelled",
          },
          {
            title: "Uncompleted",
            icon: "mdi-close-circle-outline",
            iconClass: "",
            subtitle: "List and retry uncompleted orders",
            path: "/uncompleted",
          },
        ],
      },
      pipeline: {
        admin: true,
        homeDisplay: true,
        icon: "mdi-account",
        items: [
          {
            title: "Pipeline",
            icon: "mdi-account",
            iconClass: "",
            subtitle: "Manage pipeline",
            path: "/pipeline",
          },
        ],
      },
      access: {
        admin: false,
        homeDisplay: true,
        icon: "mdi-account",
        items: [
          {
            title: "Profile",
            icon: "mdi-account",
            iconClass: "",
            subtitle: "See your locations and concepts access",
            path: "/profile",
          },
        ],
      },
    },
  },
};
